import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const CartSection = () => {
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const savedCart = JSON.parse(sessionStorage.getItem("cart")) || [];
    setCartItems(savedCart);
  }, []);

  const handleRemove = (id) => {
    const updated = cartItems.filter((item) => item.id !== id);
    setCartItems(updated);
    sessionStorage.setItem("cart", JSON.stringify(updated));
    toast.success("Item removed from cart");
  };

  const updateQty = (id, dir) => {
    const updated = cartItems.map((item) =>
      item.id === id
        ? {
            ...item,
            quantity:
              dir === "inc"
                ? item.quantity + 1
                : Math.max(1, item.quantity - 1),
          }
        : item
    );
    setCartItems(updated);
    sessionStorage.setItem("cart", JSON.stringify(updated));
  };

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * (item.quantity || 1),
    0
  );
  const tax = subtotal > 0 ? 10 : 0;
  const total = subtotal + tax;

  return (
    <section className="sx-cart">
      <div className="container container-lg">
        <h2 className="sx-cart-title">Shopping Cart</h2>

        {cartItems.length === 0 ? (
          <div className="sx-empty">
            <h4>Your cart is empty</h4>
            <Link to="/" className="sx-btn-dark">
              Continue Shopping
            </Link>
          </div>
        ) : (
          <div className="row g-4">
            {/* CART ITEMS */}
            <div className="col-lg-8">
              {cartItems.map((item) => (
                <div className="sx-cart-item" key={item.id}>
                  <img src={item.imageUrl} alt={item.name} />

                  <div className="sx-cart-info">
                    <Link to={`/product/${item.id}`}>
                      <h5>{item.name}</h5>
                    </Link>
                    <span className="sx-meta">
                      Fast delivery • Warranty included
                    </span>

                    <div className="sx-qty">
                      <button onClick={() => updateQty(item.id, "dec")}>
                        −
                      </button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQty(item.id, "inc")}>
                        +
                      </button>
                    </div>
                  </div>

                  <div className="sx-cart-price">
                    <strong>${item.price}</strong>
                    <span>${(item.price * item.quantity).toFixed(2)}</span>

                    <button onClick={() => handleRemove(item.id)}>×</button>
                  </div>
                </div>
              ))}
            </div>

            {/* SUMMARY */}
            <div className="col-lg-4">
              <div className="sx-summary">
                <h4>Order Summary</h4>

                <div className="sx-row">
                  <span>Subtotal</span>
                  <strong>${subtotal.toFixed(2)}</strong>
                </div>

                <div className="sx-row">
                  <span>Tax</span>
                  <strong>${tax.toFixed(2)}</strong>
                </div>

                <div className="sx-row total">
                  <span>Total</span>
                  <strong>${total.toFixed(2)}</strong>
                </div>

                <Link to="/checkout" className="sx-btn-dark full">
                  Proceed to Checkout
                </Link>

                <img
                  src="/assets/images/thumbs/payment-method.png"
                  alt="Payments"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* STYLES */}
      <style>{`
        .sx-cart {
          padding: 80px 0;
          background: #f5f7fb;
        }

        .sx-cart-title {
          text-align: center;
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 40px;
        }

        .sx-empty {
          text-align: center;
          padding: 80px 0;
        }

        .sx-btn-dark {
          display: inline-block;
          background: #111;
          color: #fff;
          padding: 14px 30px;
          text-decoration: none;
          font-weight: 600;
          margin-top: 16px;
        }

        .sx-cart-item {
          display: flex;
          gap: 20px;
          background: #fff;
          padding: 20px;
          margin-bottom: 18px;
          align-items: center;
          border: 1px solid #e5e7eb;
        }

        .sx-cart-item img {
          width: 100px;
          height: 100px;
          object-fit: contain;
        }

        .sx-cart-info {
          flex: 1;
        }

        .sx-cart-info h5 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 4px;
          color: #111;
        }

        .sx-meta {
          font-size: 13px;
          color: #666;
        }

        .sx-qty {
          display: inline-flex;
          margin-top: 12px;
          border: 1px solid #ddd;
        }

        .sx-qty button {
          width: 34px;
          background: #f5f5f7;
          border: none;
          font-size: 18px;
          cursor: pointer;
        }

        .sx-qty span {
          width: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
        }

        .sx-cart-price {
          text-align: right;
        }

        .sx-cart-price strong {
          display: block;
          font-size: 17px;
        }

        .sx-cart-price span {
          font-size: 14px;
          color: #555;
        }

        .sx-cart-price button {
          margin-top: 10px;
          background: none;
          border: none;
          font-size: 18px;
          color: #d00;
          cursor: pointer;
        }

        .sx-summary {
          background: #fff;
          padding: 30px;
          border: 1px solid #e5e7eb;
        }

        .sx-summary h4 {
          margin-bottom: 20px;
          font-weight: 600;
        }

        .sx-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          font-size: 15px;
        }

        .sx-row.total {
          font-size: 18px;
          font-weight: 700;
          margin-top: 16px;
        }

        .sx-btn-dark.full {
          width: 100%;
          text-align: center;
          margin-top: 20px;
        }

        .sx-summary img {
          width: 60%;
          display: block;
          margin: 20px auto 0;
        }

        @media (max-width: 768px) {
          .sx-cart-item {
            flex-direction: column;
            text-align: center;
          }

          .sx-cart-price {
            text-align: center;
          }
        }
      `}</style>
    </section>
  );
};

export default CartSection;
